import { mapGetters } from "vuex"
import { COOKIE_CONSENT } from "@/enums/cookies"

const consentCookieMixin = {
    computed: {
        ...mapGetters("cookie", [
            "cookie",
            "marketingCookieAllowed",
            "functionalCookieAllowed",
            "performanceCookieAllowed",
        ]),
    },
    mounted() {
        if (navigator && navigator.userAgent.indexOf("gonative") > -1) {
            this.setConsentCookies({
                performance: 1,
                marketing: 1,
                functional: 1,
            })
        } else {
            if (!this.cookie) {
                this.$store.dispatch("cookie/init")
            }
        }
    },
    methods: {
        setFunctionalCookie(accepted) {
            let cookie = this.$cookies.get(COOKIE_CONSENT) ?? {}
            cookie.functional = accepted ? 1 : 0
            this.$store.dispatch("cookie/setCookie", cookie)
        },
        setPerformanceCookie(accepted) {
            let cookie = this.$cookies.get(COOKIE_CONSENT) ?? {}
            cookie.performance = accepted ? 1 : 0
            this.$store.dispatch("cookie/setCookie", cookie)
        },
        setMarketingCookie(accepted) {
            let cookie = this.$cookies.get(COOKIE_CONSENT) ?? {}
            cookie.marketing = accepted ? 1 : 0
            this.$store.dispatch("cookie/setCookie", cookie)
        },
        setConsentCookies({ marketing, functional, performance }) {
            this.$store.dispatch("cookie/setCookie", {
                marketing,
                functional,
                performance,
            })
        },
    },
}

export default consentCookieMixin
